import { Routes, Route, Navigate } from "react-router-dom";
import { DashboardShell } from "@/components/dashboard/DashboardShell";
import { adminConfig } from "@/config/admin";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Overview from "./overview";
import Community from "./community";
import Donors from "./donors";
import Finance from "./finance";
import HaafPayments from "./haaf-payments";
import Manage from "./settings";

export default function AdminDashboard() {
  return (
    <ProtectedRoute allowedRoles={["admin"]}>
      <DashboardShell navItems={adminConfig.sidebarNav}>
        <Routes>
          <Route path="overview" element={<Overview />} />
          <Route path="community" element={<Community />} />
          <Route path="donors" element={<Donors />} />
          <Route path="finance" element={<Finance />} />
          <Route path="haaf-payments/*" element={<HaafPayments />} />
          <Route path="manage" element={<Manage />} />
          <Route path="*" element={<Navigate to="overview" replace />} />
        </Routes>
      </DashboardShell>
    </ProtectedRoute>
  );
}
